class SizeHelper extends HTMLElement {
  connectedCallback() {
    this.textElement = this.querySelector('[data-size-helper-text]');
    this.mapElement = this.querySelector('[data-size-helper-map]');
    this.productInfo = document.getElementById(this.dataset.productInfoId);

    if (!this.textElement || !this.mapElement || !this.productInfo) return;

    try {
      this.sizeMap = JSON.parse(this.mapElement.textContent);
    } catch {
      this.sizeMap = {};
    }

    this.update = this.update.bind(this);
    this.productInfo.addEventListener('change', this.update);

    setTimeout(this.update, 100);
  }

  disconnectedCallback() {
    this.productInfo?.removeEventListener('change', this.update);
  }

  normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace('litres', 'litre')
      .replace('liters', 'litre')
      .replace('liter', 'litre');
  }

  getSelectedSize() {
    const checkedInputs = this.productInfo.querySelectorAll('input[type="radio"]:checked');

    for (const input of checkedInputs) {
      const label = this.productInfo.querySelector(`label[for="${input.id}"]`);
      const value = this.normalize(label?.textContent || input.value);

      if (this.sizeMap[value]) return value;
    }

    const selects = this.productInfo.querySelectorAll('select');

    for (const select of selects) {
      const value = this.normalize(select.selectedOptions?.[0]?.textContent || select.value);

      if (this.sizeMap[value]) return value;
    }

    return null;
  }

  update() {
    const selectedSize = this.getSelectedSize();
    const message = selectedSize ? this.sizeMap[selectedSize] : '';

    if (!message) return;

    this.textElement.textContent = message;
    this.classList.add('is-visible');
  }
}

if (!customElements.get('size-helper')) {
  customElements.define('size-helper', SizeHelper);
}